import { OrganisationService } from './../../service/organisation/organisation.service';
import { Directive, inject, Input } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Observable, of, switchMap, timer } from 'rxjs';
import { map } from 'rxjs/operators';

@Directive({
    selector: '[uflaUniqueStromNetzbetreiberNummer]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: UniqueStromNetzbetreiberNummerDirective,
            multi: true,
        },
    ],
    standalone: false,
})
export class UniqueStromNetzbetreiberNummerDirective {
    private organisationService = inject(OrganisationService);


  @Input() uflaUniqueStromNetzbetreiberNummer: string;

  validate(nameControl: AbstractControl): Observable<ValidationErrors | null> | Observable<ValidationErrors | null> | ValidationErrors {
      {
          if (!nameControl.value || this.uflaUniqueStromNetzbetreiberNummer === nameControl.value) {
              return of(null);
          }
          return timer(500).pipe(
              switchMap(() => this.organisationService.existsByStromNetzbetreiberNummer(nameControl.value)),
              map(exists => exists ? { stromNetzbetreiberNummer: true } : null),
          );
      }
  }

}
